import { useFilterQueryContext } from 'src/contexts/FilterQueryContext';
import { DateRangeSelector } from 'src/core/POS/DateRangeSelector';
import { PosEnumSelect } from 'src/core/POS/PosSelect';
import { PosTextField } from 'src/core/POS/PosTextField';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { ContentId } from 'src/utils/constants/contentId';
import { YES_NO_ENUM_FILTER_TO_CID } from 'src/utils/constants/contentIdMaps';
import { PurchaseDateRangePresetNames } from 'src/utils/dateTimeUtils';
import { FromYesNoEnum, ToYesNoEnum } from 'src/utils/eventQueryUtils';
import { Feature, UIReportV2CostOfGoodsSoldQuery } from 'src/WebApiController';

import { FilterToolbarItemId } from '../Filters';

export const costOfGoodsSoldReportMandatoryFiltersToShow: FilterToolbarItemId[] =
  ['adjustmentsSinceDate'];

export function useCostOfGoodsSoldReportFilters({
  isHorizontalLayout,
}: {
  isHorizontalLayout?: boolean;
}) {
  const { initialQuery, tempQuery, setTempQuery } =
    useFilterQueryContext<UIReportV2CostOfGoodsSoldQuery>();

  const hasDateFiltersRelativeExactCustomFeature = useUserHasFeature(
    Feature.DateFiltersRelativeExactCustom
  );

  return {
    filters: [
      {
        titleContentId: ContentId.Date,
        type: 'row',
        items: [
          {
            filterId: 'adjustmentsSinceDate' as FilterToolbarItemId,
            labelContentId: ContentId.ChangeDate,
            filterQueryKeys: ['adjustmentsSinceDate'] as FilterToolbarItemId[],
            filterItem: (
              <DateRangeSelector
                useRelativePresets={
                  // This is a deprecated prop. Remove once DateFiltersRelativeExactCustom is GA'ed
                  hasDateFiltersRelativeExactCustomFeature ? false : true
                }
                presetNames={PurchaseDateRangePresetNames}
                exactPresetNames={
                  hasDateFiltersRelativeExactCustomFeature
                    ? PurchaseDateRangePresetNames
                    : undefined
                }
                trailingPresetNames={
                  hasDateFiltersRelativeExactCustomFeature
                    ? PurchaseDateRangePresetNames
                    : undefined
                }
                value={tempQuery.adjustmentsSinceDate}
                defaultValue={initialQuery.adjustmentsSinceDate}
                onChange={({ value }) =>
                  setTempQuery({
                    ...tempQuery,
                    adjustmentsSinceDate: value,
                  })
                }
                onBlur={({ value }) =>
                  setTempQuery({
                    ...tempQuery,
                    adjustmentsSinceDate: value,
                  })
                }
              />
            ),
          },
        ],
      },
      {
        titleContentId: ContentId.Filters,
        type: 'row',
        items: [
          {
            filterId: 'adjustmentType' as FilterToolbarItemId,
            labelContentId: ContentId.AdjustmentType,
            filterQueryKeys: ['adjustmentType' as FilterToolbarItemId],
            filterItem: (
              <PosTextField
                style={{ width: '100%' }}
                value={tempQuery.adjustmentType || ''}
                placeholder="All"
                onChange={(e) =>
                  setTempQuery({
                    ...tempQuery,
                    adjustmentType: e.target.value || null,
                  })
                }
              />
            ),
          },
          {
            filterId: 'isActive' as FilterToolbarItemId,
            labelContentId: ContentId.Active,
            filterQueryKeys: ['isActive' as FilterToolbarItemId],
            filterItem: (
              <PosEnumSelect
                style={{ width: '100%' }}
                value={ToYesNoEnum(tempQuery.isActive)}
                placeholderText={ContentId.All}
                enableEmptySelection
                onChange={(yesNoEnumValue) => {
                  const newIsActive = FromYesNoEnum(yesNoEnumValue);
                  if (newIsActive !== tempQuery.isActive) {
                    setTempQuery({
                      ...tempQuery,
                      isActive: newIsActive,
                    });
                  }
                }}
                valueOptionsContent={YES_NO_ENUM_FILTER_TO_CID}
              />
            ),
          },
        ],
      },
    ],
  };
}
